<template>
  <div>
    <BasicSalaryAmount
        v-model="form.incomeEmployedBasicSalary"
        :errors-post="errorsPost.incomeEmployedBasicSalary"
        :object-id="objectId"
        :no-save="noSave"
    />

    <JobTitle
        v-model="form.incomeEmployedJobTitle"
        :errors-post="errorsPost.incomeEmployedJobTitle"
        :object-id="objectId"
        :no-save="noSave"
    />

    <StartDate
        v-model="form.incomeCommonStartDate"
        :errors-post="errorsPost.incomeCommonStartDate"
        :object-id="objectId"
        :no-save="noSave"
    />

    <ContractType
        v-model="form.incomeEmployedContractType"
        :errors-post="errorsPost.incomeEmployedContractType"
        :object-id="objectId"
        :no-save="noSave"
    />

    <hr>

    <CompanyName
        v-model="form.incomeCommonBusinessName"
        :errors-post="errorsPost.incomeCommonBusinessName"
        :object-id="objectId"
        :no-save="noSave"
        title="Your employers company name"
    />

    <BusinessAddress
        v-model="form.incomeCommonBusinessAddress"
        :form="form"
        :errors-post="errorsPost.incomeCommonBusinessAddress"
        :object-id="objectId"
        :no-save="noSave"
        title="Your employers address"
    />

    <EmployerSector
        v-model="form.incomeCommonBusinessSector"
        :errors-post="errorsPost.incomeCommonBusinessSector"
        :object-id="objectId"
        :no-save="noSave"
    />

  </div>
</template>

<script>
import BasicSalaryAmount from "@/components/common/questionnaires/question/questions/clientIncome/BasicSalaryAmount";
import JobTitle from "@/components/common/questionnaires/question/questions/clientIncome/JobTitle";
import StartDate from "@/components/common/questionnaires/question/questions/clientIncome/StartDate";
import ContractType from "@/components/common/questionnaires/question/questions/clientIncome/ContractType";
import BusinessAddress from "@/components/common/questionnaires/question/questions/clientIncome/BusinessAddress";
import CompanyName from "@/components/common/questionnaires/question/questions/clientPerson/professional/CompanyName";
import EmployerSector from "@/components/common/questionnaires/question/questions/clientIncome/EmployerSector";

export default {
  name: 'Employed',
  components: {
    EmployerSector,
    CompanyName,
    BusinessAddress,
    ContractType,
    StartDate,
    JobTitle,
    BasicSalaryAmount
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    objectId: {
      type: Number,
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  }
}

</script>
